import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-software-integration',
  templateUrl: './software-integration.component.html',
  styleUrls: ['./software-integration.component.scss']
})
export class SoftwareIntegrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
